(() => {
  const timers = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-countdown]').forEach(box => {
      if (timers.has(box)) return;
      const target = Date.parse(box.dataset.countdown);
      if (!Number.isFinite(target)) return;
      const units = box.querySelectorAll('[data-unit]');
      function tick() {
        const diff = Math.max(0, target - Date.now());
        const values = [Math.floor(diff / 86400000), Math.floor(diff / 3600000) % 24, Math.floor(diff / 60000) % 60, Math.floor(diff / 1000) % 60];
        units.forEach((el, i) => { el.textContent = String(values[i]).padStart(2, '0'); });
        if (diff === 0) {
          const note = box.closest('.countdown-flex')?.querySelector('[data-countdown-note]');
          if (note) note.textContent = box.dataset.expired || 'The event date has arrived.';
        }
      }
      tick();
      timers.set(box, setInterval(tick, 1000));
    });
    root.querySelectorAll('[data-faq-search]').forEach(input => {
      if (input.dataset.initialized) return;
      input.dataset.initialized = 'true';
      const page = input.closest('.tf-page');
      if (!page) return;
      input.addEventListener('input', () => {
        const query = input.value.toLocaleLowerCase().trim();
        let matches = 0;
        page.querySelectorAll('[data-faq-item]').forEach(item => {
          item.hidden = !!query && !item.textContent.toLocaleLowerCase().includes(query);
          if (!item.hidden) matches++;
        });
        page.querySelectorAll('[data-faq-group]').forEach(group => { group.hidden = !group.querySelector('[data-faq-item]:not([hidden])'); });
        const empty = page.querySelector('[data-faq-empty]');
        if (empty) empty.hidden = matches !== 0;
      });
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-menu-toggle]');
    if (!button) return;
    const menu = document.getElementById(button.getAttribute('aria-controls'));
    if (menu) button.setAttribute('aria-expanded', String(menu.classList.toggle('open')));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-menu-toggle][aria-expanded="true"]').forEach(button => {
      document.getElementById(button.getAttribute('aria-controls'))?.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-product-variants]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const price = select.closest('.product-panel')?.querySelector('[data-price]');
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    timers.forEach((timer, box) => {
      if (event.target.contains(box)) { clearInterval(timer); timers.delete(box); }
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  initialize();
})();
